<template>
  <v-slide-y-transition mode="out-in">
    <router-view />
  </v-slide-y-transition>
</template>

<script>
  export default { name: 'App' }
</script>

<style lang="scss">
a {
  text-decoration: none;
}
</style>
